import React from "react";
import { Page, Navbar, List, ListItem } from "framework7-react";

const BidDetailPage = () => {
  return (
    <Page className="no-scroll bg-white" >
      <Navbar title="Invoice" noShadow backLink="Back"/>
      <List mediaList>
        <ListItem title="Yellow Submarine" subtitle="Beatles">
          <img
            slot="media"
            src="https://cdn.framework7.io/placeholder/fashion-88x88-1.jpg"
            width="44"
          />
        </ListItem>
        <ListItem link="#" title="Don't Stop Me Now" subtitle="Queen">
          <img
            slot="media"
            src="https://cdn.framework7.io/placeholder/fashion-88x88-2.jpg"
            width="44"
          />
        </ListItem>
        <ListItem title="Godwin Robby" subtitle="Paid via Card $ 563.23">
          <img
            slot="media"
            src="https://cdn.framework7.io/placeholder/fashion-88x88-3.jpg"
            width="44"
          />
        </ListItem>
      </List>
    </Page>
  );
};

export default BidDetailPage;